import DrawerLayout from "client/common/components/stackables/DrawerLayout";
import { useCurrentDrawer } from "client/common/hooks/stackables";
import Banner from "client/common/components/content/Banner";
import Markdown from "client/common/components/content/Markdown";

import { useRebateQuery } from "../hooks";

export type RebateDrawerProps = {
  id: number;
};

const RebateDrawer = ({ id }: RebateDrawerProps) => {
  const { close } = useCurrentDrawer();

  const { data: rebate, error, isLoading } = useRebateQuery(id);

  if (isLoading) {
    return <DrawerLayout.Loading />;
  }

  if (error || !rebate) {
    return <DrawerLayout.FetchError error={error} entityName="Rebate" />;
  }

  return (
    <DrawerLayout>
      <DrawerLayout.Header title="Rebate offer details" onClose={close} />
      <DrawerLayout.Content>
        <Banner variant="promotion">
          <Banner.Content label={rebate.promo_title} description={rebate.promo_message} />
        </Banner>
        {rebate.promo_details && <Markdown markdown={rebate.promo_details} />}
      </DrawerLayout.Content>
    </DrawerLayout>
  );
};

export default RebateDrawer;
